import { ScheduleFreezeReason } from '@/features/dashboard/plannedTransactions/types/ScheduleFreezeReason.ts';

/**
 * Etykiety w rodzaju żeńskim, bo podmiotem zdania jest rata — tak samo jak
 * w `PlannedTransactionPaymentStatus.utils.ts`.
 */
export const scheduleFreezeReasonLabels: Record<ScheduleFreezeReason, string> =
  {
    [ScheduleFreezeReason.PAID]: 'opłacona',
    [ScheduleFreezeReason.CANCELLED]: 'anulowana',
    [ScheduleFreezeReason.OPEN_ONLINE_PAYMENT]: 'otwarta płatność online',
    [ScheduleFreezeReason.REFUND]: 'zwrot',
    [ScheduleFreezeReason.NON_POSITIVE_AMOUNT]: 'kwota niedodatnia',
  };

export const getScheduleFreezeReasonLabel = (
  reason: ScheduleFreezeReason,
): string => scheduleFreezeReasonLabels[reason];

/** Pełne zdanie do dymka wiersza — czemu ta rata została nietknięta. */
export const scheduleFreezeReasonHints: Record<ScheduleFreezeReason, string> = {
  [ScheduleFreezeReason.PAID]:
    'Rata jest opłacona — zmiany nie da się wprowadzić wstecz.',
  [ScheduleFreezeReason.CANCELLED]:
    'Rata jest anulowana, więc nie jest już należnością.',
  [ScheduleFreezeReason.OPEN_ONLINE_PAYMENT]:
    'Klient ma otwarty link do płatności z zamrożoną kwotą tej raty.',
  [ScheduleFreezeReason.REFUND]:
    'To zwrot do klienta, a nie jego należność — poza rozkładem dopłaty.',
  [ScheduleFreezeReason.NON_POSITIVE_AMOUNT]:
    'Kwota niedodatnia — nie ma czym wchłonąć zmiany.',
};
